/**
 * Poll data service.
 */

angular.module('hjSurveysModule').service('PollData', function (Restangular, RestangularV3) {
    function getRestangularPoll(siteId, pollId) {
        return Restangular.one('sites', siteId).one('polls', pollId);
    }

    function getRestangularPollV3(siteId, pollId) {
        return RestangularV3.one('sites', siteId).one('polls', pollId);
    }

    function getRestangularPollResponse(siteId, pollId, responseId) {
        return RestangularV3.one('sites', siteId).one('polls', pollId).one('responses', responseId);
    }

    this.loadPoll = function (siteId, pollId) {
        return getRestangularPollV3(siteId, pollId).get();
    };

    this.getRestangularPoll = function (siteId, pollId) {
        return getRestangularPollV3(siteId, pollId);
    };

    this.getRestangularPollResponse = function (siteId, pollId, responseId) {
        return getRestangularPollResponse(siteId, pollId, responseId).get();
    };

    this.restangularizeResponse = function (siteId, pollId, response) {
        return Restangular.restangularizeElement(getRestangularPoll(siteId, pollId), response, 'responses');
    };
});
